import React from 'react';
import { ApolloProvider } from '@apollo/client';
import useGravitonClient from 'hooks/useGravitonClient';
import PropTypes from 'prop-types';

const { REACT_APP_GRAPHQL_SLEEP } = process.env;

const GraphQLContainer = (WrappedComponent) => function WrapperFunction(
  {
    gravitonUrl = '',
    xGravitonHeaderPublic = '',
    ...restProps
  },
) {
  const { client } = useGravitonClient({ gravitonUrl, xGravitonHeaderPublic, sleepTime: REACT_APP_GRAPHQL_SLEEP });

  if (!client) {
    return null;
  }

  return (
    <ApolloProvider client={client}>
      <WrappedComponent {...restProps} />
    </ApolloProvider>
  );
};

GraphQLContainer.propTypes = {
  gravitonUrl: PropTypes.string,
  xGrabitonHeaderPublic: PropTypes.string,
};

export default GraphQLContainer;
